export default "__VITE_ASSET__Cbpd0vFf__"